import assignment from 'assignment';
import deepFreze from 'deep-freeze';

import {
  addKeywordAutocompleteCustomToken,
  addKeywordAutocompleteToken,
  addWorkplaceAutocompleteCustomToken,
  addWorkplaceAutocompleteToken,
  generateKeywordAutocompleteTokens,
  generateWorkplaceAutocompleteTokens,
  removeKeywordAutocompleteToken,
  removeWorkplaceAutocompleteToken,
  setAutocompleteLatestSearch,
  showKeywordAutocompleteLatest,
  showWorkplaceAutocompleteLatest,
  updateKeywordAutocompleteSuggestions,
  updateKeywordAutocompleteValue,
  updateWorkplaceAutocompleteSuggestions,
  updateWorkplaceAutocompleteValue
} from 'src/redux/reducers/utils/autocomplete';
import {
  ADD_KEYWORD_AUTOCOMPLETE_CUSTOM_TOKEN,
  ADD_KEYWORD_AUTOCOMPLETE_TOKEN,
  ADD_WORKPLACE_AUTOCOMPLETE_CUSTOM_TOKEN,
  ADD_WORKPLACE_AUTOCOMPLETE_TOKEN,
  CHECK_RADIUS,
  GENERATE_KEYWORD_AUTOCOMPLETE_TOKENS,
  GENERATE_WORKPLACE_AUTOCOMPLETE_TOKENS,
  REMOVE_KEYWORD_AUTOCOMPLETE_TOKEN,
  REMOVE_WORKPLACE_AUTOCOMPLETE_TOKEN,
  SET_AUTOCOMPLETE_LATEST_SEARCH,
  SET_RADIUS,
  SHOW_KEYWORD_AUTOCOMPLETE_LATEST,
  SHOW_WORKPLACE_AUTOCOMPLETE_LATEST,
  UPDATE_KEYWORD_AUTOCOMPLETE_SUGGESTIONS,
  UPDATE_KEYWORD_AUTOCOMPLETE_VALUE,
  UPDATE_WORKPLACE_AUTOCOMPLETE_SUGGESTIONS,
  UPDATE_WORKPLACE_AUTOCOMPLETE_VALUE
} from 'src/redux/constant/actionsType';


const initialSearchParameters = {
  keyword: [],
  workplace: [],
  regions: [],
  countries: [],
  employers: [],
  skills: [],
  radius: 30,
  radiusDisabled: false
};

const initialSearchParametersState = {
  current: initialSearchParameters,
  autocomplete: {
    workplace: {
      suggestions: [],
      tokens: [],
      latest: [],
      value: ''
    },
    keyword: {
      suggestions: [],
      tokens: [],
      latest: [],
      value: ''
    }
  }
};

const setRadius = (state, action) => {
  deepFreze(state);
  return assignment({}, state, {
    current: {
      radius: action.state
    }
  });
};

const getRadiusDisabledState = ({ autocomplete: { workplace: { tokens, value } } }) => {
  const hasValueAndNoChips = (value.length > 0) && (tokens.length < 1);
  const hasOneChipWorkplace = (tokens.length === 1)
    && (tokens.filter(({ name }) => name !== 'workplace').length < 1)
    && (value.length < 1);

  const enable = hasValueAndNoChips || hasOneChipWorkplace;
  return !enable;
};

const disableRadius = (state) => {
  deepFreze(state);

  const radiusDisabled = getRadiusDisabledState(state);
  const radius = radiusDisabled ? initialSearchParameters.radius : state.current.radius;

  return assignment({}, state, {
    current: {
      radiusDisabled,
      radius
    }
  });
};

export default (state = initialSearchParametersState, action = {}) => {
  const payload = {
    [UPDATE_WORKPLACE_AUTOCOMPLETE_SUGGESTIONS]: updateWorkplaceAutocompleteSuggestions,
    [ADD_WORKPLACE_AUTOCOMPLETE_TOKEN]: addWorkplaceAutocompleteToken,
    [ADD_WORKPLACE_AUTOCOMPLETE_CUSTOM_TOKEN]: addWorkplaceAutocompleteCustomToken,
    [REMOVE_WORKPLACE_AUTOCOMPLETE_TOKEN]: removeWorkplaceAutocompleteToken,
    [SHOW_WORKPLACE_AUTOCOMPLETE_LATEST]: showWorkplaceAutocompleteLatest,
    [GENERATE_WORKPLACE_AUTOCOMPLETE_TOKENS]: generateWorkplaceAutocompleteTokens,

    [UPDATE_KEYWORD_AUTOCOMPLETE_SUGGESTIONS]: updateKeywordAutocompleteSuggestions,
    [ADD_KEYWORD_AUTOCOMPLETE_TOKEN]: addKeywordAutocompleteToken,
    [ADD_KEYWORD_AUTOCOMPLETE_CUSTOM_TOKEN]: addKeywordAutocompleteCustomToken,
    [REMOVE_KEYWORD_AUTOCOMPLETE_TOKEN]: removeKeywordAutocompleteToken,
    [SHOW_KEYWORD_AUTOCOMPLETE_LATEST]: showKeywordAutocompleteLatest,
    [GENERATE_KEYWORD_AUTOCOMPLETE_TOKENS]: generateKeywordAutocompleteTokens,

    [UPDATE_WORKPLACE_AUTOCOMPLETE_VALUE]: updateWorkplaceAutocompleteValue,
    [UPDATE_KEYWORD_AUTOCOMPLETE_VALUE]: updateKeywordAutocompleteValue,

    [SET_AUTOCOMPLETE_LATEST_SEARCH]: setAutocompleteLatestSearch,
    [SET_RADIUS]: setRadius,
    [CHECK_RADIUS]: disableRadius
  };
  return (payload[action.type] || (() => state))(state, action);
};
